import { orderBy, find, flatten, uniqBy, uniq, cloneDeep, map, some, filter, findIndex, unionBy } from 'lodash';
import { populateRegData, getDefaultSortParamForDivision } from '../utils/events';
import { SortType } from '../components/ColumnHeader';
import { drawPlayerTags, acceptanceBucketTypes, acceptanceRankingValues, drawEliminationTypes, utrTypes } from '../utils/eventConstants';

import {
    EVENTS_REINIT_STATE,
    EVENTS_FETCH_FAILURE,
    EVENTS_FETCH_REQUEST,
    EVENTS_FETCH_SUCCESS,
    EVENTS_DRAWS_VIEW_FETCH_REQUEST,
    EVENTS_DRAWS_VIEW_FETCH_SUCCESS,
    EVENTS_DRAWS_VIEW_FETCH_FAILURE,
    EVENTS_SAVE_FAILURE,
    EVENTS_SAVE_REQUEST,
    EVENTS_SAVE_SUCCESS,
    EVENTS_UPDATE_SUCCESS,
    EVENTS_DELETE_FAILURE,
    EVENTS_DRAWS_INIT_REQUEST,
    EVENTS_DRAWS_INIT_SUCCESS,
    EVENTS_DRAWS_INIT_FAILURE,
    EVENTS_DRAWS_AUTOFILL_REQUEST,
    EVENTS_DRAWS_AUTOFILL_SUCCESS,
    EVENTS_DRAWS_AUTOFILL_FAILURE,
    EVENTS_DRAWS_PUBLISH_REQUEST,
    EVENTS_DRAWS_PUBLISH_SUCCESS,
    EVENTS_DRAWS_PUBLISH_FAILURE,
    EVENTS_DRAWS_SAVE_REQUEST,
    EVENTS_DRAWS_SAVE_SUCCESS,
    EVENTS_DRAWS_SAVE_FAILURE,
    EVENTS_POST_SCORE_SUCCESS,
    EVENTS_CLEAR_SCORE_SUCCESS,
    EVENTS_REG_SUCCESS,
    EVENTS_SET_JUST_PUBLISHED_FLAG,
    EVENTS_CLEAR_JUST_PUBLISHED_FLAG,
    EVENTS_DRAWS_FETCH_REQUEST,
    EVENTS_DRAWS_FETCH_SUCCESS,
    EVENTS_DRAWS_FETCH_FAILURE,
    EVENTS_LOCATIONS_FETCH_REQUEST,
    EVENTS_LOCATIONS_FETCH_SUCCESS,
    EVENTS_LOCATIONS_FETCH_FAILURE,
    EVENTS_LOCATIONS_EXCLUDE_REQUEST,
    EVENTS_LOCATIONS_EXCLUDE_SUCCESS,
    EVENTS_LOCATIONS_EXCLUDE_FAILURE,
    EVENTS_OFFICIALS_FETCH_REQUEST,
    EVENTS_OFFICIALS_FETCH_SUCCESS,
    EVENTS_OFFICIALS_FETCH_FAILURE,
    EVENTS_GET_MATCH_OFFICIALS_SUCCESS,
    EVENTS_DRAWS_DELETE_SUCCESS,
    EVENTS_INVITE_PLAYERS_REQUEST,
    EVENTS_INVITE_PLAYERS_SUCCESS,
    EVENTS_INVITE_PLAYERS_FAILURE,
    EVENTS_REGPAYMENTS_FETCH_REQUEST,
    EVENTS_REGPAYMENTS_FETCH_SUCCESS,
    EVENTS_REGPAYMENTS_FETCH_FAILURE,
    EVENTS_ACCEPTANCE_FETCH_REQUEST,
    EVENTS_ACCEPTANCE_FETCH_SUCCESS,
    EVENTS_ACCEPTANCE_FETCH_FAILURE,
    EVENTS_FETCH_ATTACHMENT_REQUEST,
    EVENTS_FETCH_ATTACHMENT_SUCCESS,
    EVENTS_FETCH_ATTACHMENT_FAILURE,
    EVENTS_SET_OVERVIEW_TAB_STATE,
    EVENTS_SET_DRAWS_TAB_STATE,
    EVENTS_SET_PLAYERS_TAB_STATE,
    EVENTS_HIDE_DELETE_FAILED_POPUP,
    EVENTS_REG_ADD_TEAMMATE,
    EVENTS_UPDATE_DRAWS,
    EVENTS_UPDATE_SCHEDULE_TYPE,
    EVENTS_GET_DRAW_OFFICIALS_SUCCESS,
    EVENTS_FETCH_MATCH_SHEET_SUCCESS,
    EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS,
    EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS,
    EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS,
    EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS,
    EVENTS_UPDATE_MATCH_SHEET_SUCCESS,
    EVENTS_DELETE_MATCH_SHEET_SUCCESS,
    EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS,
    EVENTS_ADD_TEAM_STANDING_SUCCESS,
    EVENTS_EVENT_TEAM_STANDINGS_SUCCESS,
    EVENTS_DELETE_TEAM_STANDING_SUCCESS,
    EVENTS_EDIT_TEAM_STANDING_SUCCESS,
    EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS,
    EVENTS_OMIT_FROM_CONFERENCE_SUCCESS,
    EVENTS_DRAW_CONTACTS_SUCCESS,
    EVENTS_PUBLISH_SUCCESS,
    EVENTS_UNPUBLISH_SUCCESS,
    EVENTS_SAFESPORT_FETCH_REQUEST,
    EVENTS_SAFESPORT_FETCH_SUCCESS,
    EVENTS_GET_EVENT_REGIONS_FETCH,
    EVENTS_GET_EVENT_REGIONS_SUCCESS,
    EVENTS_GET_ORGANIZER_RATINGS_SUCCESS,
    EVENTS_SET_ORGANIZER_RATINGS_SUCCESS,
    EVENTS_SET_PLAYER_WILDCARD_SUCCESS,
    EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS,
    EVENTS_SET_DRAW_TAG_SUCCESS,
    EVENTS_POST_NCSA_REG,
    EVENTS_POST_NCSA_REG_SUCCESS,
    EVENTS_POST_NCSA_REG_FAILURE,
    EVENTS_CLEAR,
    EVENTS_ADD_DIVISION,
    EVENTS_META_FETCH_SUCCESS,
    EVENTS_UPDATE_TEAM_SCORES_SUCCESS,
    EVENTS_CROP_BANNER_PHOTO_SUCCESS,
    EVENTS_REMOVE_BANNER_PHOTO_SUCCESS,
    EVENTS_SHOW_ADMIN_SPLASH,
    EVENTS_HIDE_ADMIN_SPLASH,
    EVENTS_UPDATE_MATCH_POSITION_REQUEST,
    EVENTS_UPDATE_MATCH_POSITION_SUCCESS,
    EVENTS_ADD_MATCH_TO_ROUND,
    EVENTS_DELETE_MATCH,
    EVENTS_ADD_DRAW,
    EVENTS_UPDATE_DRAW,
    EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS,
    EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS,
    TOGGLE_EVENT_LOADING,
} from '../actions/actionTypes/event-action-types';

const _ = { orderBy, find, flatten, uniq, cloneDeep, map, some, filter, findIndex, unionBy };

const initialState = {
    currentEvent: {
        isLoading: false,
        error: false,
        data: null,
        matchSheet: [],
        acceptance: {},
        drawsFetchState: {
            loading: false,
            loaded: false,
            error: null,
        },
        overviewTabState: {
            divisionsExpanded: false,
            descriptionExpanded: false,
        },
        drawsTabState: {
            activeRound: 0,
        },
        playersTabState: {
            filter: null,
        },
        metaData: {},
        orderOfPlay: null,
        regions: {
            data: [],
            error: null,
            loading: false,
            loaded: false,
        },
    },
    regPaymentRefund: {
        loading: false,
        loaded: false,
        error: null,
    },
    adminSplash: null,
    drawOfficials: null,
    teamStandings: null,
    contacts: null,
    organizerRatings: null,
    ncsaReg: {
        loading: false,
        success: false,
    },
};

const handleReinitState = () => initialState;

const handleDrawContactsSuccess = (state, action) => ({
    ...state,
    contacts: action.payload,
});

const handleEditTeamStandingSuccess = (state, action) => ({
    ...state,
    teamStandings: state.teamStandings.map(standing => {
        if (standing.id === action.payload.id) {
            return { ...action.payload };
        }
        return standing;
    }),
});

const handleDeleteTeamStandingSuccess = (state, action) => ({
    ...state,
    teamStandings: state.teamStandings.filter(({ id }) => id !== action.payload),
});

const handleEventTeamStandingsSuccess = (state, action) => ({
    ...state,
    teamStandings: action.payload,
});

const handleAddTeamStandingSuccess = (state, action) => ({
    ...state,
    teamStandings: [
        ...(state.teamStandings || []),
        action.payload,
    ],
});

const handleUpdateMatchSheetSuccess = (state, action) => {
    const draws = _.cloneDeep(state.currentEvent?.data?.draws || []);
    const { matchId, payload } = action.data;

    const drawToUpdate = draws.reduce((accumulator, draw) => {
        const rounds = draw.rounds.filter(round => round.matches.some(match => match.id === matchId));
        if (rounds.length > 0) {
            accumulator.push({
                id: draw.id,
                rounds,
            });
        }
        return accumulator;
    }, []);

    if (drawToUpdate.length > 0) {
        const round = drawToUpdate[0].rounds[0];
        const matchIndex = _.findIndex(round.matches, m => m.id === matchId);
        round.matches[matchIndex].date = payload.date;
        const drawIndex = _.findIndex(draws, d => d.id === drawToUpdate[0].id);
        const roundIndex = _.findIndex(draws[drawIndex].rounds, r => r.id === round.id);
        draws[drawIndex].rounds[roundIndex] = round;
    }
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleUpdateMatchSheetRoundSuccess = (state, action) => {
    const draws = _.cloneDeep(state.currentEvent?.data?.draws || []);
    const { roundId, payload } = action.data;
    let roundFound;
    draws.forEach(draw => {
        draw.rounds.forEach(round => {
            if (round.id === roundId) {
                roundFound = true;
                round.matches.forEach(match => {
                    match.date = payload.date;
                });
            }
        });
        if (!roundFound && draw.childDraws) {
            draw.childDraws.forEach(childDraw => {
                childDraw.rounds.forEach(round => {
                    if (round.id === roundId) {
                        roundFound = true;
                        round.matches.forEach(match => {
                            match.date = payload.date;
                        });
                    }
                });
            });
        }
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleDeleteMatchSheetSuccess = (state, action) => {
    const draws = _.cloneDeep(state.currentEvent?.data?.draws || []);
    const { matchId } = action.data;
    let matchFound;
    draws.forEach(draw => {
        draw.rounds.forEach(round => {
            round.matches.forEach(match => {
                if (match.id === matchId) {
                    matchFound = true;
                    match.date = null;
                }
            });
        });
        if (!matchFound && draw.childDraws) {
            draw.childDraws.forEach(childDraw => {
                childDraw.rounds.forEach(round => {
                    round.matches.forEach(match => {
                        if (match.id === matchId) {
                            match.date = null;
                        }
                    });
                });
            });
        }
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleOrderOfPlayFetchSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        orderOfPlay: action.payload,
        matchSheet: [],
    },
});

const handleOrderOfPlaySaveSuccess = (state, action) => {
    const { matchId, matches } = action.payload;
    const updatedMatch = matches.find(m => m.matchId === matchId);
    const draws = _.cloneDeep(state.currentEvent?.data?.draws || []);
    let matchFound;
    draws.forEach(draw => {
        draw.rounds.forEach(round => {
            round.matches.forEach(match => {
                if (match.id === matchId) {
                    matchFound = true;
                    match.date = updatedMatch.date;
                }
            });
        });
        if (!matchFound && draw.childDraws) {
            draw.childDraws.forEach(childDraw => {
                childDraw.rounds.forEach(round => {
                    round.matches.forEach(match => {
                        if (match.id === matchId) {
                            match.date = updatedMatch.date;
                        }
                    });
                });
            });
        }
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            orderOfPlay: _.unionBy(state.currentEvent.orderOfPlay, matches, 'matchId'),
            matchSheet: [],
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleOrderOfPlayDeleteSuccess = (state, action) => {
    const { matchId } = action.payload;
    const draws = _.cloneDeep(state.currentEvent?.data?.draws || []);

    let matchFound;
    draws.forEach(draw => {
        draw.rounds.forEach(round => {
            round.matches.forEach(match => {
                if (match.id === matchId) {
                    matchFound = true;
                    match.date = null;
                }
            });
        });
        if (!matchFound && draw.childDraws) {
            draw.childDraws.forEach(childDraw => {
                childDraw.rounds.forEach(round => {
                    round.matches.forEach(match => {
                        if (match.id === matchId) {
                            match.date = null;
                        }
                    });
                });
            });
        }
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            orderOfPlay: state.currentEvent.orderOfPlay.filter(match => match.id === matchId),
            matchSheet: [],
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleDeleteFailure = state => ({
    ...state,
    deleteEventFailed: true,
});

const handleHideDeleteFailedPopup = state => ({
    ...state,
    deleteEventFailed: false,
});

const handleSaveSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        isSaving: false,
        wasUpdated: true,
    },
});

const handleUpdateSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: action.res.data,
        wasUpdated: true,
    },
});

const handleFetchRequest = state => ({
    ...state,
    isLoading: true,
    wasUpdated: false,
});

const handleDrawsSaveRequest = state => ({
    ...state,
    isSaving: true,
    wasUpdated: false,
});

const handleEventDataFetchSuccess = (state, action) => {
    const event = populateRegData(action.res.data);

    if (action.type !== EVENTS_FETCH_SUCCESS && state.currentEvent.data?.currentMember) {
        event.currentMember = { ...state.currentEvent.data?.currentMember };
    }

    event.draws = _.orderBy(event.draws, draw => draw.name?.toLowerCase(), SortType.ASC);
    const playersDict = {};
    if (event?.registeredPlayers?.length) {
        event.registeredPlayers.forEach(player => {
            playersDict[player.id] = player;
        });
        _.orderBy(event.registeredPlayers, event.utrType.value === utrTypes.SANCTIONED ? ['ratingStatusSinglesVal', 'utrSingles'] : 'myUtrSingles', [SortType.DESC, SortType.DESC]);
    }

    const teamsDict = {};
    if (event?.teams?.length) {
        (event?.teams || []).forEach(team => {
            teamsDict[team.id] = team;
        });
        _.orderBy(event.teams, event.utrType.value === utrTypes.SANCTIONED ? 'averageDoublesUtr' : 'averageDoublesMyUtr', SortType.DESC);
    }
    (event?.draws || []).forEach(draw => {
        if (draw.eliminationType?.value === drawEliminationTypes.MATCH_PLAY) {
            event.teams.forEach(team => {
                if (draw.teams.indexOf(team.id) !== -1) {
                    draw.players.push(team.players);
                }
            });
            draw.players = _.uniq(_.flatten(draw.players));
        }
    });
    const playersTabState = event.eventDivisions?.length ? {
        divisionId: event.eventDivisions[0].id,
        divisionName: event.eventDivisions[0].name,
        registeredCount: event.eventDivisions[0].registeredCount,
        selectedStatus: {
            value: 'registered',
            label: 'Registered',
        },
        sortParam: getDefaultSortParamForDivision(event.eventDivisions[0]),
        sortType: SortType.DESC,
    } : null;
    return {
        ...state,
        isLoading: false,
        isSaving: false,
        currentEvent: {
            ...state.currentEvent,
            error: false,
            data: event,
            playersDict,
            teamsDict,
            playersTabState,
            drawsTabState: {
                activeRound: 0,
            },
            overviewTabState: {
                divisionsExpanded: false,
                descriptionExpanded: false,
            },

        },
    };
};

const handleDrawsViewFetchSuccess = (state, action) => {
    const event = action.res.data;
    event.draws = orderBy(event.draws, draw => draw.name?.toLowerCase(), SortType.ASC);

    const playersDict = {};
    (event.registeredPlayers || []).forEach(player => {
        playersDict[player.id] = player;
    });

    const teamsDict = {};
    (event.teams || []).forEach(team => {
        teamsDict[team.id] = team;
    });

    // match_play draws aggregate the players of their referenced teams
    // so DrawsTabContent can resolve match positions to player IDs.
    event.draws.forEach(draw => {
        if (draw.eliminationType?.value === drawEliminationTypes.MATCH_PLAY) {
            if (!draw.players) {
                draw.players = [];
            }
            (event.teams || []).forEach(team => {
                if (draw.teams?.indexOf(team.id) !== -1) {
                    draw.players.push(team.players);
                }
            });
            draw.players = uniq(flatten(draw.players));
        }
    });

    return {
        ...state,
        isLoading: false,
        currentEvent: {
            ...state.currentEvent,
            error: false,
            data: event,
            playersDict,
            teamsDict,
            drawsTabState: {
                activeRound: 0,
            },
        },
    };
};

const handleEventDataFetchFailure = (state, action) => ({
    ...state,
    isLoading: false,
    currentEvent: {
        error: (action.res ? action.res.data.error : true) || true,
        data: null,
        locations: null,
        officials: null,
        redirectUrl: action.data ? action.data.redirectUrl : null,
    },
});

const handleDrawsSaveFailure = (state, action) => ({
    ...state,
    isLoading: false,
    isSaving: false,
    currentEvent: {
        error: (action.res ? action.res.data.error : true) || true,
    },
});

const handleDrawsAutofillFailure = (state, action) => ({
    ...state,
    isLoading: false,
    isSaving: false,
    currentEvent: {
        ...state.currentEvent,
        error: (action.res ? action.res.data.error : true) || true,
    },
});

const setMatchResultInRounds = (rounds, roundIndex, matchIndex, result) => rounds.map((round, ri) => {
    if (ri !== roundIndex) {
        return round;
    }
    const matches = round.matches.map((match, mi) => (mi === matchIndex ? { ...match, result } : match));
    return { ...round, matches };
});

const updateScoreInDraw = (draw, childDrawIndex, roundIndex, matchIndex, result) => {
    if (childDrawIndex == null) {
        return { ...draw, rounds: setMatchResultInRounds(draw.rounds, roundIndex, matchIndex, result) };
    }
    const childDraws = draw.childDraws.map((childDraw, ci) => (
        ci === childDrawIndex
            ? { ...childDraw, rounds: setMatchResultInRounds(childDraw.rounds, roundIndex, matchIndex, result) }
            : childDraw
    ));
    return { ...draw, childDraws };
};

const handleScoreUpdateSuccess = (state, action) => {
    const { drawIndex, childDrawIndex, roundIndex, matchIndex } = action.indexes;
    const draws = state.currentEvent.data.draws.map((draw, di) => (
        di === drawIndex
            ? updateScoreInDraw(draw, childDrawIndex, roundIndex, matchIndex, action.result)
            : draw
    ));
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleDrawsFetchRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        drawsFetchState: {
            loading: true,
            loaded: false,
            error: null,
        },
    },
});

const handleDrawsFetchFailure = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        drawsFetchState: {
            loading: false,
            loaded: true,
            error: 'Failed to load draws',
        },
    },
});

const handleDrawsFetchSuccess = (state, action) => {
    const draws = action.data;
    draws.forEach(draw => {
        if (draw.eliminationType?.value === drawEliminationTypes.MATCH_PLAY) {
            state.currentEvent.data.teams.forEach(team => {
                if (draw.teams.indexOf(team.id) !== -1) {
                    draw.players.push(team.players);
                }
            });
            draw.players = _.uniq(_.flatten(draw.players));
        }
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
            drawsFetchState: {
                loading: false,
                loaded: true,
                error: null,
            },
        },
    };
};

const handleLocationsFetchRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        locations: null,
        locationsFetchState: {
            loading: true,
            loaded: false,
            error: null,
        },
    },
});

const handleLocationsFetchFailure = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        locations: null,
        locationsFetchState: {
            loading: false,
            loaded: true,
            error: 'Failed to load locations',
        },
    },
});

const handleLocationsFetchSuccess = (state, action) => {
    const { locations } = action.data;
    locations.forEach(loc => {
        loc.facilities.forEach(fac => {
            fac.enabled = fac.courts.some(court => court.enabled);
        });
        loc.enabled = loc.facilities.some(fac => fac.enabled);
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            locations,
            locationsFetchState: {
                loading: false,
                loaded: true,
                error: null,
            },
        },
    };
};

const handleLocationsExcludeRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        locationsFetchState: {
            ...state.currentEvent.locationsFetchState,
            updating: true,
        },
    },
});

const handleLocationsExcludeDone = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        locationsFetchState: {
            ...state.currentEvent.locationsFetchState,
            updating: false,
        },
    },
});

const handleOfficialsFetchRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        officials: null,
        officialsFetchState: {
            loading: true,
            loaded: false,
            error: null,
        },
    },
});

const handleOfficialsFetchFailure = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        officials: null,
        officialsFetchState: {
            loading: false,
            loaded: true,
            error: 'Failed to load officials',
        },
    },
});

const handleOfficialsFetchSuccess = (state, action) => {
    const { officials } = action.data;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            officials,
            officialsFetchState: {
                loading: false,
                loaded: true,
                error: null,
            },
        },
    };
};

const handleGetDrawOfficialsSuccess = (state, action) => {
    const merged = uniqBy([...(state.drawOfficials === null ? [] : state.drawOfficials), ...action.payload.data.matches], 'id');
    return {
        ...state,
        drawOfficials: merged,
    };
};

const handleDeleteMatchOfficialSuccess = (state, action) => ({
    ...state,
    drawOfficials: state.drawOfficials.filter(official => official.id !== action.payload.matchId),
});

const handleFetchMatchSheetSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        matchSheet: action.data,
        orderOfPlay: null,
    },
});

const handleAddDivision = (state, action) => {
    const { key, player } = action;
    return {
        ...state,
        [key]: player,
        inviteSuccess: false,
    };
};

const handleCropBannerPhotoSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        wasUpdated: true,
        data: {
            ...state.currentEvent.data,
            photoUrl: action.res.data.bannerUrl,
        },
    },
});

const handleRemoveBannerPhotoSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        wasUpdated: true,
        data: {
            ...state.currentEvent.data,
            photoUrl: null,
        },
    },
});

const handleSetJustPublishedFlag = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        justPublished: true,
    },
});

const handleClearJustPublishedFlag = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        justPublished: false,
    },
});

const handleMetaFetchSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        metaData: action.data,
    },
});

const handleUpdateTeamScoresSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            teamEventScoreDetail: action.data,
        },
    },
});

const handleShowAdminSplash = (state, action) => ({
    ...state,
    adminSplash: action.message,
});

const handleHideAdminSplash = state => ({
    ...state,
    adminSplash: null,
});

const handleUpdateMatchPositionRequest = (state, action) => {
    const { drawId, matchId, position, data } = action;
    const typeId = data.type === 'player' ? 1 : 2;
    const firstPlayerId = data.players?.[0] ?? null;
    const id = data.type === 'player' ? firstPlayerId : data.id;
    let teams; let rounds; let matches; let
        teamsDict;

    if (data.type === 'team' && !_.find(state.currentEvent.data.teams, { id: data.id })) {
        teams = [...state.currentEvent.data.teams, data];
        teamsDict = {};
        teams.forEach(team => {
            teamsDict[team.id] = team;
        });
    }

    const draws = state.currentEvent.data.draws.map(draw => {
        if (draw.id === drawId) {
            rounds = draw.rounds.map((round, ri) => {
                if (ri === 0) {
                    matches = round.matches.map(match => {
                        if (match.id === matchId) {
                            return {
                                ...match,
                                [position]: (!id ? null : {
                                    id,
                                    type: {
                                        id: typeId,
                                        value: data.type,
                                    },
                                }),
                                result: null,
                                isSaving: true,
                            };
                        }
                        return match;
                    });
                    return {
                        ...round,
                        matches,
                    };
                }
                return round;
            });
            return {
                ...draw,
                rounds,
            };
        }
        return draw;
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
                ...(teams ? { teams } : {}),
                isSaving: true,
            },
            ...(teamsDict ? { teamsDict } : {}),
        },
    };
};

const handleUpdateMatchPositionSuccess = (state, action) => {
    const { drawId, matchId } = action;
    let rounds; let
        matches;

    const draws = state.currentEvent.data.draws.map(draw => {
        if (draw.id === drawId) {
            rounds = draw.rounds.map((round, ri) => {
                if (ri === 0) {
                    matches = round.matches.map(match => {
                        if (match.id === matchId) {
                            return {
                                ...match,
                                isSaving: false,
                            };
                        }
                        return match;
                    });
                    return {
                        ...round,
                        matches,
                    };
                }
                return round;
            });
            return {
                ...draw,
                rounds,
            };
        }
        return draw;
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
                isSaving: false,
            },
        },
    };
};

const handleAddMatchToRound = (state, action) => {
    const { drawId, roundId, matchIds } = action;
    let rounds;

    const matchDraw = state.currentEvent.data.draws.find(draw => draw.id === drawId);
    const matchRound = matchDraw.rounds.find(round => round.id === roundId);

    const newMatches = [];
    matchIds.forEach(id => {
        newMatches.push({
            id,
            round: roundId,
            poisition1: null,
            position2: null,
            location: null,
            date: matchRound && state.currentEvent.data.eventType?.value === 'dual_match' ? matchRound.date : null,
            detail: null,
            result: null,
        });
    });

    const draws = state.currentEvent.data.draws.map(draw => {
        if (draw.id === drawId) {
            rounds = draw.rounds.map((round, ri) => {
                if (ri === 0) {
                    return {
                        ...round,
                        matches: [...round.matches, ...newMatches],
                    };
                }
                return round;
            });
            return {
                ...draw,
                rounds,
            };
        }
        return draw;
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleDeleteMatch = (state, action) => {
    const { drawId, matchId } = action;
    let rounds;

    const draws = state.currentEvent.data.draws.map(draw => {
        if (draw.id === drawId) {
            rounds = draw.rounds.map((round, ri) => {
                if (ri === 0) {
                    return {
                        ...round,
                        matches: round.matches.filter(match => {
                            return match.id !== matchId;
                        }),
                    };
                }
                return round;
            });
            return {
                ...draw,
                rounds,
            };
        }
        return draw;
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handlePublishSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            published: true,
        },
    },
});

const handleUnpublishSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            published: false,
        },
    },
});

const handleAddDraw = (state, action) => {
    const { draw } = action;
    const draws = _.orderBy([...state.currentEvent.data.draws, draw], ['drawFormatType.id', 'name'], [SortType.ASC, SortType.ASC]);

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleUpdateDraw = (state, action) => {
    const { drawId, drawName } = action;
    const draws = _.orderBy(state.currentEvent.data.draws.map(draw => {
        if (draw.id === drawId) {
            return {
                ...draw,
                name: drawName,
            };
        }
        return draw;
    }), ['drawFormatType.id', 'name'], [SortType.ASC, SortType.ASC]);

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleDrawsDeleteSuccess = (state, action) => {
    const { drawId } = action;
    const draws = [...state.currentEvent.data.draws].filter(draw => {
        return draw.id !== drawId;
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                draws,
            },
        },
    };
};

const handleInvitePlayersRequest = state => ({
    ...state,
    isLoading: true,
});

const handleInvitePlayersFailure = state => ({
    ...state,
    isLoading: false,
});

const handleInvitePlayersSuccess = (state, action) => ({
    ...state,
    isLoading: false,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            invites: action.data.data.invites,
        },
    },
});

const handleAcceptanceFetchRequest = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        acceptance: {
            ...(state.currentEvent.acceptance || {}),
            [action.divisionId]: {
                loading: true,
                loaded: false,
                error: null,
            },
        },
    },
});

const handleAcceptanceFetchFailure = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        acceptance: {
            ...(state.currentEvent.acceptance || {}),
            [action.divisionId]: {
                loading: false,
                loaded: false,
                error: 'Failed to load acceptance list',
            },
        },
    },
});

const handleAcceptanceFetchSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        playersTabState: {
            ...state.currentEvent.playersTabState,
            sortAcceptanceType: acceptanceRankingValues.WTA,
            sortListParam: 'wtaOrder',
            sortListType: SortType.ASC,
        },
        acceptance: {
            ...(state.currentEvent.acceptance || {}),
            [action.divisionId]: {
                ...action.data,
                loading: false,
                loaded: true,
                error: null,
            },
        },
    },
});

const handleFetchAttachmentReset = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        attachments: [],
    },
});

const handleFetchAttachmentSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        attachments: action.data.items,
    },
});

const handleRegPaymentsFetchRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        regPaymentRefund: {
            loading: true,
            loaded: false,
            error: null,
        },
    },
});

const handleRegPaymentsFetchFailure = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        regPaymentRefund: {
            loading: false,
            loaded: true,
            error: 'Failed to load reg payments',
        },
    },
});

const handleRegPaymentsFetchSuccess = (state, action) => {
    const { divisionAmounts } = action.data;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            regPaymentRefund: {
                divisionAmounts,
                loading: false,
                loaded: true,
                error: null,
            },
        },
    };
};

const handleSetOverviewTabState = (state, action) => {
    const { overviewTabState } = action.payload;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            overviewTabState,
        },
    };
};

const handleSetDrawsTabState = (state, action) => {
    const { drawsTabState } = action.payload;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            drawsTabState,
        },
    };
};

const handleSetPlayersTabState = (state, action) => {
    const { playersTabState } = action.payload;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            playersTabState,
        },
    };
};

const handleRegAddTeammate = (state, action) => {
    const { divisionIndex, player2 } = action.payload;
    const eventDivisions = [...state.currentEvent.data.eventDivisions].map((div, i) => {
        if (i === divisionIndex) {
            return {
                ...div,
                player2,
            };
        }
        return div;
    });
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                eventDivisions,
            },
        },
    };
};

const handleToggleEventLoading = (state, action) => ({
    ...state,
    isLoading: action.payload,
});

const handleUpdateDraws = (state, action) => {
    const { draws, registeredPlayers, teams } = action.payload;
    const event = state.currentEvent.data;

    let playersDict;
    if (registeredPlayers?.length) {
        playersDict = {};
        registeredPlayers.forEach(player => {
            playersDict[player.id] = player;
        });
        _.orderBy(registeredPlayers, event.utrType.value === utrTypes.SANCTIONED ? ['ratingStatusSinglesVal', 'utrSingles'] : 'myUtrSingles', [SortType.DESC, SortType.DESC]);
    }

    let teamsDict;
    if (teams?.length) {
        teamsDict = {};
        teams.forEach(team => {
            teamsDict[team.id] = team;
        });
        _.orderBy(teams, event.utrType.value === utrTypes.SANCTIONED ? 'averageDoublesUtr' : 'averageDoublesMyUtr', SortType.DESC);
    }

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            data: {
                ...state.currentEvent.data,
                ...(draws ? { draws } : {}),
                ...(registeredPlayers ? { registeredPlayers } : {}),
                ...(teams ? { teams } : {}),
            },
            ...(playersDict ? { playersDict } : {}),
            ...(teamsDict ? { teamsDict } : {}),
        },
    };
};

const handleGetMatchOfficialsSuccess = (state, action) => {
    const { matchId, data } = action.payload;
    const newMatchDetails = {
        id: matchId,
        officials: data,
    };
    return {
        ...state,
        drawOfficials: [...state.drawOfficials, newMatchDetails],
    };
};

const handleUpdateScheduleType = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            scheduleType: action.payload,
        },
    },
});

const handleIncludeInConferenceSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            eventSettings: {
                ...state.currentEvent.data?.eventSettings,
                isConference: true,
            },
        },
    },
});

const handleOmitFromConferenceSuccess = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            eventSettings: {
                ...state.currentEvent.data?.eventSettings,
                isConference: false,
            },
        },
    },
});

const handleSafesportFetchRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            hasSafeSportCertifiedOrganizer: false,
        },
    },
});

const handleSafesportFetchSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        data: {
            ...state.currentEvent.data,
            hasSafeSportCertifiedOrganizer: action.res.data.hasSafeSportCertifiedOrganizer,
        },
    },
});

const handleSaveRequest = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        isSaving: true,
    },
});

const handleSaveFailure = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        isSaving: false,
    },
});

const handleGetEventRegionsSuccess = (state, action) => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        regions: {
            ...state.currentEvent.regions,
            data: action.payload,
            error: null,
            loaded: true,
            loading: false,
        },
    },
});

const handleGetEventRegionsFetch = state => ({
    ...state,
    currentEvent: {
        ...state.currentEvent,
        regions: {
            ...state.currentEvent.regions,
            data: [],
            error: null,
            loaded: false,
            loading: true,
        },
    },
});

const handleGetOrganizerRatingsSuccess = (state, action) => ({
    ...state,
    organizerRatings: action.payload,
});

const handleSetOrganizerRatingsSuccess = state => ({
    ...state,
});

const handleSetPlayerWildcardSuccess = (state, action) => {
    const { divisionId, memberId, wildcardStateId } = action.payload;
    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            acceptance: {
                ...state.currentEvent.acceptance,
                [divisionId]: {
                    ...state.currentEvent.acceptance[divisionId],
                    buckets: state.currentEvent.acceptance[divisionId].buckets.map(bucket => {
                        bucket.players = bucket.players.map(player => {
                            // eslint-disable-next-line eqeqeq
                            if (player.memberId == memberId) {
                                player.acceptanceListWildcardStateId = wildcardStateId;
                            }
                            return player;
                        });
                        return bucket;
                    }),
                },
            },
        },
    };
};

const handleMovePlayerToRoundSuccess = (state, action) => {
    const { divisionId, memberId, roundType, isSpecialExempt } = action.payload;
    const { buckets } = state.currentEvent.acceptance[divisionId];
    const bucketToUpdate = buckets.findIndex(t => t.type === roundType);
    buckets.forEach(b => {
        const player = b.players.find(p => p.memberId === memberId);
        if (player) {
            if (roundType === acceptanceBucketTypes.MAIN && isSpecialExempt) {
                player.acceptanceType = acceptanceRankingValues.WTA;
                player.acceptanceListWildcardStateId = 4; // special exempt
            }

            b.players = b.players.filter(p => p.memberId !== memberId);
            buckets[bucketToUpdate].players.push(player);
        }
    });

    return {
        ...state,
        currentEvent: {
            ...state.currentEvent,
            acceptance: {
                ...state.currentEvent.acceptance,
                [divisionId]: {
                    ...state.currentEvent.acceptance[divisionId],
                    buckets,
                },
            },
        },
    };
};

const handleSetDrawTagSuccess = (state, action) => {
    const { drawId, memberId, teamId, tagId } = action.payload;
    let registeredPlayers;
    let teams;
    const playersDict = {};
    const teamsDict = {};
    if (memberId) {
        registeredPlayers = state.currentEvent.data.registeredPlayers.map(player => {
            if (player.memberId === memberId) {
                player.draws[drawId].tag = { id: tagId, value: drawPlayerTags[tagId] };
            }
            playersDict[player.id] = player;
            return player;
        });
        _.orderBy(registeredPlayers, state.currentEvent.data.utrType.value === utrTypes.SANCTIONED ? ['ratingStatusSinglesVal', 'utrSingles'] : 'myUtrSingles', [SortType.DESC, SortType.DESC]);

        return {
            ...state,
            currentEvent: {
                ...state.currentEvent,
                data: {
                    ...state.currentEvent.data,
                    registeredPlayers,
                },
                playersDict,
            },
        };
    }
    if (teamId) {
        teams = state.currentEvent.data.teams.map(team => {
            if (team.id === teamId) {
                team.draws[drawId].tag = { id: tagId, value: drawPlayerTags[tagId] };
            }
            teamsDict[team.id] = team;
            return team;
        });
        _.orderBy(teams, state.currentEvent.data.utrType.value === utrTypes.SANCTIONED ? 'averageDoublesUtr' : 'averageDoublesMyUtr', SortType.DESC);

        return {
            ...state,
            currentEvent: {
                ...state.currentEvent,
                data: {
                    ...state.currentEvent.data,
                    teams,
                },
                teamsDict,
            },
        };
    }
    return state;
};

const handlePostNcsaReg = state => ({
    ...state,
    ncsaReg: {
        loading: true,
        success: false,
    },
});

const handlePostNcsaRegSuccess = state => ({
    ...state,
    ncsaReg: {
        loading: false,
        success: true,
    },
});

const handlePostNcsaRegFailure = state => ({
    ...state,
    ncsaReg: {
        loading: false,
        success: false,
    },
});

const handlers = {
    [EVENTS_REINIT_STATE]: handleReinitState,
    [EVENTS_DRAW_CONTACTS_SUCCESS]: handleDrawContactsSuccess,
    [EVENTS_EDIT_TEAM_STANDING_SUCCESS]: handleEditTeamStandingSuccess,
    [EVENTS_DELETE_TEAM_STANDING_SUCCESS]: handleDeleteTeamStandingSuccess,
    [EVENTS_EVENT_TEAM_STANDINGS_SUCCESS]: handleEventTeamStandingsSuccess,
    [EVENTS_ADD_TEAM_STANDING_SUCCESS]: handleAddTeamStandingSuccess,
    [EVENTS_UPDATE_MATCH_SHEET_SUCCESS]: handleUpdateMatchSheetSuccess,
    [EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS]: handleUpdateMatchSheetRoundSuccess,
    [EVENTS_DELETE_MATCH_SHEET_SUCCESS]: handleDeleteMatchSheetSuccess,
    [EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS]: handleOrderOfPlayFetchSuccess,
    [EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS]: handleOrderOfPlaySaveSuccess,
    [EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS]: handleOrderOfPlayDeleteSuccess,
    [EVENTS_DELETE_FAILURE]: handleDeleteFailure,
    [EVENTS_HIDE_DELETE_FAILED_POPUP]: handleHideDeleteFailedPopup,
    [EVENTS_SAVE_SUCCESS]: handleSaveSuccess,
    [EVENTS_UPDATE_SUCCESS]: handleUpdateSuccess,
    [EVENTS_FETCH_REQUEST]: handleFetchRequest,
    [EVENTS_DRAWS_INIT_REQUEST]: handleFetchRequest,
    [EVENTS_DRAWS_VIEW_FETCH_REQUEST]: handleFetchRequest,
    [EVENTS_DRAWS_AUTOFILL_REQUEST]: handleDrawsSaveRequest,
    [EVENTS_DRAWS_PUBLISH_REQUEST]: handleDrawsSaveRequest,
    [EVENTS_DRAWS_SAVE_REQUEST]: handleDrawsSaveRequest,
    [EVENTS_FETCH_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_DRAWS_INIT_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_DRAWS_AUTOFILL_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_DRAWS_PUBLISH_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_DRAWS_SAVE_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_REG_SUCCESS]: handleEventDataFetchSuccess,
    [EVENTS_DRAWS_VIEW_FETCH_SUCCESS]: handleDrawsViewFetchSuccess,
    [EVENTS_DRAWS_VIEW_FETCH_FAILURE]: handleEventDataFetchFailure,
    [EVENTS_FETCH_FAILURE]: handleEventDataFetchFailure,
    [EVENTS_DRAWS_INIT_FAILURE]: handleDrawsSaveFailure,
    [EVENTS_DRAWS_PUBLISH_FAILURE]: handleDrawsSaveFailure,
    [EVENTS_DRAWS_SAVE_FAILURE]: handleDrawsSaveFailure,
    [EVENTS_DRAWS_AUTOFILL_FAILURE]: handleDrawsAutofillFailure,
    [EVENTS_POST_SCORE_SUCCESS]: handleScoreUpdateSuccess,
    [EVENTS_CLEAR_SCORE_SUCCESS]: handleScoreUpdateSuccess,
    [EVENTS_DRAWS_FETCH_REQUEST]: handleDrawsFetchRequest,
    [EVENTS_DRAWS_FETCH_FAILURE]: handleDrawsFetchFailure,
    [EVENTS_DRAWS_FETCH_SUCCESS]: handleDrawsFetchSuccess,
    [EVENTS_LOCATIONS_FETCH_REQUEST]: handleLocationsFetchRequest,
    [EVENTS_LOCATIONS_FETCH_FAILURE]: handleLocationsFetchFailure,
    [EVENTS_LOCATIONS_FETCH_SUCCESS]: handleLocationsFetchSuccess,
    [EVENTS_LOCATIONS_EXCLUDE_REQUEST]: handleLocationsExcludeRequest,
    [EVENTS_LOCATIONS_EXCLUDE_SUCCESS]: handleLocationsExcludeDone,
    [EVENTS_LOCATIONS_EXCLUDE_FAILURE]: handleLocationsExcludeDone,
    [EVENTS_OFFICIALS_FETCH_REQUEST]: handleOfficialsFetchRequest,
    [EVENTS_OFFICIALS_FETCH_FAILURE]: handleOfficialsFetchFailure,
    [EVENTS_OFFICIALS_FETCH_SUCCESS]: handleOfficialsFetchSuccess,
    [EVENTS_GET_DRAW_OFFICIALS_SUCCESS]: handleGetDrawOfficialsSuccess,
    [EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS]: handleDeleteMatchOfficialSuccess,
    [EVENTS_FETCH_MATCH_SHEET_SUCCESS]: handleFetchMatchSheetSuccess,
    [EVENTS_ADD_DIVISION]: handleAddDivision,
    [EVENTS_CLEAR]: handleReinitState,
    [EVENTS_CROP_BANNER_PHOTO_SUCCESS]: handleCropBannerPhotoSuccess,
    [EVENTS_REMOVE_BANNER_PHOTO_SUCCESS]: handleRemoveBannerPhotoSuccess,
    [EVENTS_SET_JUST_PUBLISHED_FLAG]: handleSetJustPublishedFlag,
    [EVENTS_CLEAR_JUST_PUBLISHED_FLAG]: handleClearJustPublishedFlag,
    [EVENTS_META_FETCH_SUCCESS]: handleMetaFetchSuccess,
    [EVENTS_UPDATE_TEAM_SCORES_SUCCESS]: handleUpdateTeamScoresSuccess,
    [EVENTS_SHOW_ADMIN_SPLASH]: handleShowAdminSplash,
    [EVENTS_HIDE_ADMIN_SPLASH]: handleHideAdminSplash,
    [EVENTS_UPDATE_MATCH_POSITION_REQUEST]: handleUpdateMatchPositionRequest,
    [EVENTS_UPDATE_MATCH_POSITION_SUCCESS]: handleUpdateMatchPositionSuccess,
    [EVENTS_ADD_MATCH_TO_ROUND]: handleAddMatchToRound,
    [EVENTS_DELETE_MATCH]: handleDeleteMatch,
    [EVENTS_PUBLISH_SUCCESS]: handlePublishSuccess,
    [EVENTS_UNPUBLISH_SUCCESS]: handleUnpublishSuccess,
    [EVENTS_ADD_DRAW]: handleAddDraw,
    [EVENTS_UPDATE_DRAW]: handleUpdateDraw,
    [EVENTS_DRAWS_DELETE_SUCCESS]: handleDrawsDeleteSuccess,
    [EVENTS_INVITE_PLAYERS_REQUEST]: handleInvitePlayersRequest,
    [EVENTS_INVITE_PLAYERS_FAILURE]: handleInvitePlayersFailure,
    [EVENTS_INVITE_PLAYERS_SUCCESS]: handleInvitePlayersSuccess,
    [EVENTS_ACCEPTANCE_FETCH_REQUEST]: handleAcceptanceFetchRequest,
    [EVENTS_ACCEPTANCE_FETCH_FAILURE]: handleAcceptanceFetchFailure,
    [EVENTS_ACCEPTANCE_FETCH_SUCCESS]: handleAcceptanceFetchSuccess,
    [EVENTS_FETCH_ATTACHMENT_REQUEST]: handleFetchAttachmentReset,
    [EVENTS_FETCH_ATTACHMENT_SUCCESS]: handleFetchAttachmentSuccess,
    [EVENTS_FETCH_ATTACHMENT_FAILURE]: handleFetchAttachmentReset,
    [EVENTS_REGPAYMENTS_FETCH_REQUEST]: handleRegPaymentsFetchRequest,
    [EVENTS_REGPAYMENTS_FETCH_FAILURE]: handleRegPaymentsFetchFailure,
    [EVENTS_REGPAYMENTS_FETCH_SUCCESS]: handleRegPaymentsFetchSuccess,
    [EVENTS_SET_OVERVIEW_TAB_STATE]: handleSetOverviewTabState,
    [EVENTS_SET_DRAWS_TAB_STATE]: handleSetDrawsTabState,
    [EVENTS_SET_PLAYERS_TAB_STATE]: handleSetPlayersTabState,
    [EVENTS_REG_ADD_TEAMMATE]: handleRegAddTeammate,
    [TOGGLE_EVENT_LOADING]: handleToggleEventLoading,
    [EVENTS_UPDATE_DRAWS]: handleUpdateDraws,
    [EVENTS_GET_MATCH_OFFICIALS_SUCCESS]: handleGetMatchOfficialsSuccess,
    [EVENTS_UPDATE_SCHEDULE_TYPE]: handleUpdateScheduleType,
    [EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS]: handleIncludeInConferenceSuccess,
    [EVENTS_OMIT_FROM_CONFERENCE_SUCCESS]: handleOmitFromConferenceSuccess,
    [EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS]: handleIncludeInConferenceSuccess,
    [EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS]: handleOmitFromConferenceSuccess,
    [EVENTS_SAFESPORT_FETCH_REQUEST]: handleSafesportFetchRequest,
    [EVENTS_SAFESPORT_FETCH_SUCCESS]: handleSafesportFetchSuccess,
    [EVENTS_SAVE_REQUEST]: handleSaveRequest,
    [EVENTS_SAVE_FAILURE]: handleSaveFailure,
    [EVENTS_GET_EVENT_REGIONS_SUCCESS]: handleGetEventRegionsSuccess,
    [EVENTS_GET_EVENT_REGIONS_FETCH]: handleGetEventRegionsFetch,
    [EVENTS_GET_ORGANIZER_RATINGS_SUCCESS]: handleGetOrganizerRatingsSuccess,
    [EVENTS_SET_ORGANIZER_RATINGS_SUCCESS]: handleSetOrganizerRatingsSuccess,
    [EVENTS_SET_PLAYER_WILDCARD_SUCCESS]: handleSetPlayerWildcardSuccess,
    [EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS]: handleMovePlayerToRoundSuccess,
    [EVENTS_SET_DRAW_TAG_SUCCESS]: handleSetDrawTagSuccess,
    [EVENTS_POST_NCSA_REG]: handlePostNcsaReg,
    [EVENTS_POST_NCSA_REG_SUCCESS]: handlePostNcsaRegSuccess,
    [EVENTS_POST_NCSA_REG_FAILURE]: handlePostNcsaRegFailure,
};

function eventsReducer(state = initialState, action) {
    const handler = handlers[action.type];
    return handler ? handler(state, action) : state;
}

export default eventsReducer;
